//
// Copyright (c) 2011-2019 by Curalate, Inc.
//

import { createSelector } from 'reselect';

import { IContentLibraryItem } from '@apis/content-library/contentLibraryApiModel';
import { splitMentionedItemsCombiner } from '@galleries/selectors/splitMentionedItemsCombiner';
import { IDefaultInstagramAccount } from '@instagram-account/redux/account/instagramAccountModel';
import { ICuralateStore } from '@models/AppState';
import { IConnectedBrandInstagramBusinessAccounts } from '@apis/instagram-settings/gatewayInstagramSettingsApiModel';
import { getHasMultiHandleInstagramEnabled } from '@account-settings/redux/facebook-instagram/selectors/getMultiHandleFeature';

export const getNonMentionedItems = createSelector(
  (state: ICuralateStore) =>
    state.galleries.requestRightsNonMentionedModal.materializedItems,
  (state: ICuralateStore) => state.instagram.account.defaultInstagramAccount,
  (state: ICuralateStore) =>
    state.facebookInstagramSettings.connectedInstagramAccounts,
  (state: ICuralateStore) => getHasMultiHandleInstagramEnabled(state),
  (
    materializedItems: IContentLibraryItem[],
    defaultInstagramAccount: IDefaultInstagramAccount | undefined,
    connectedInstagramAccounts:
      | IConnectedBrandInstagramBusinessAccounts[]
      | undefined,
    isMultiHandleFeatureEnabled: boolean,
  ) => {
    const { nonAtMentionedItems } = splitMentionedItemsCombiner(
      materializedItems,
      defaultInstagramAccount,
      connectedInstagramAccounts,
      isMultiHandleFeatureEnabled,
    );
    return nonAtMentionedItems;
  },
);
